<template>
    <div class="content-wrapper">
        <div class="row">
            <div class="col-sm-12 col-md-6">
                <app-breadcrumb :page-title="'Info Product'" :icon="'grid'"/>
            </div>
        </div>

        <app-table
            :id="tableId"
            :options="options"
            @action="getListAction"
        />
        <modal-detail
                v-if="detailModalActive"
                :table-id="tableId"
                modal-id="modal-detail"
                :selected-url="selectedUrl"
                @close-modal="closeDetailModal"
            />



    </div>
</template>

<script>
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";
import {Schema} from './SchemaInfoProduct';
import '../../../../Helpers/common/helpers'; 

export default {
    extends: CoreLibrary,
    name: "InfoProduct",
    mixins: [Schema],
    created() {
        this.options.columns = [...this.tableColumns, this.actionObj];
        // this.searchAndSelectFilterOptions();
    },
    methods: {
        getListAction(rowData, actionObj, active) {
            this.rowData = rowData;
            if (actionObj.title == 'Detail') {
                this.selectedUrl = '/master/product/' + rowData.id;
                this.openDetailModal();
            } 
        },
        closeDetailModal() {
            let m_id = `#modal-detail`;
            $(m_id).modal('hide');
            this.detailModalActive = false;
            this.reSetData();
        },
        openDetailModal() {
            this.detailModalActive = true;
        },
    },
}
</script>
